<template>
  <div class="flex flex-col gap-4">
    <BaseCard
      class="mx-auto flex max-w-120 flex-col gap-4 p-4 md:mt-6 md:w-120 md:p-6"
    >
      <TextTitle>Contact</TextTitle>
      <p>
        Repowered is op werkdagen van 08:30 tot 17:00 uur telefonisch bereikbaar
        op
        <a
          class="decoration-primary hover:text-primary underline decoration-2"
          href="tel:+310850805140"
          aria-label="Bel Repowered op 085 080 5140"
          @click="triggerEvent('contact:click-phone')"
        >
          085 080 5140</a
        >.
      </p>
      <p>
        We zijn per e-mail bereikbaar via
        <a
          class="decoration-primary hover:text-primary underline decoration-2"
          href="mailto:support@repowered.nl"
          aria-label="Mail Repowered op support@repowered.nl"
          @click="triggerEvent('contact:click-email')"
        >
          support@repowered.nl</a
        >.
      </p>
    </BaseCard>
  </div>
</template>

<script setup>
import { triggerEvent } from "@/services/plausibleService.js"
import { TextTitle, BaseCard } from "@repowerednl/ui-component-library"
</script>
